import { prop } from 'ramda';
import { createSelector } from 'reselect';

import { getSellers } from 'features/other/organizationStructureMUI/seller/selectors';

import { NAME } from './constants';

export const getNominatedSellerLogins = prop(NAME);

export const getNominatedSellers = createSelector(
	getNominatedSellerLogins,
	getSellers,
	(nominatedSellerLogins, sellers) => sellers.filter((s) => nominatedSellerLogins.includes(s.login)),
);

export const getDiscardedSellers = createSelector(
	getNominatedSellerLogins,
	getSellers,
	(nominatedSellerLogins, sellers) => sellers.filter((s) => !nominatedSellerLogins.includes(s.login)),
);
